import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=02054e6c&scoped=true"
import script from "./InputNumber.ts?vue&type=script&lang=ts&external"
export * from "./InputNumber.ts?vue&type=script&lang=ts&external"
import style0 from "./InputNumber.scss?vue&type=style&index=0&id=02054e6c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02054e6c",
  null
  
)

export default component.exports